import styled from 'styled-components'

import { helpers } from '../../../../styles/theme'
import { ButtonIcon } from '../../Shared'

type Props = {
	isActive: boolean
}

export const ButtonClear = styled(ButtonIcon)<Props>`
	padding: 0;
	margin: 0 0 0 -2px;
	min-width: auto;
	width: 24px;
	height: 100%;
	color: ${({ isActive }) => (isActive ? helpers.color.input.buttonChipClearHover : helpers.color.input.buttonChipClear)};
	background-color: ${({ isActive }) => (isActive ? helpers.color.input.buttonChipClearBackgroundHover : helpers.color.input.buttonChipClearBackground)};
	border-radius: 0 4px 4px 0;
	flex-shrink: 0;

	&:focus:enabled,
	&:active:enabled {
		color: ${({ isActive }) => (isActive ? helpers.color.input.buttonChipClearHover : helpers.color.input.buttonChipClear)};
		background-color: transparent;
		outline: none;
	}

	&:hover:enabled {
		background-color: ${helpers.color.input.buttonChipClearBackgroundHover};
		color: ${helpers.color.input.buttonChipClearHover};
	}
`
